import { useState, useEffect } from 'react';
import { TextCollectionAnnotation } from '@scale/shared/types/response/textcollection';
import { TextCollectionField } from '@scale/shared/types/params/textcollection';
import _ from 'lodash';

const isResponsePerfectFieldId = 'is_response_perfect_1_1';

// This hook contains special logics for FAIR's RLHF pipeline tasks
// More info here: https://docs.google.com/document/d/1IPSPxw1_8FtzYlX5RGMOn24RYYFl0bEWBoPrcTsPaak/edit#
export const useFairSettings = (
  isFair: boolean,
  annotations: Record<string, TextCollectionAnnotation>,
  fields: TextCollectionField[],
) => {
  const [betterOptionForQuestions, setBetterOptionForQuestions] = useState<number | undefined>(
    undefined,
  );

  useEffect(() => {
    if (!isFair) return;

    // Approach 1
    const rankingResponse = _.get(
      annotations as any,
      `ranking_multiple_chat_api_endpoints.response`,
      undefined,
    );
    if (rankingResponse && rankingResponse.length > 0 && rankingResponse[0] !== null) {
      setBetterOptionForQuestions(prevIndex => {
        const newIndex = rankingResponse[0];
        if (newIndex !== 'null' && prevIndex !== newIndex) {
          return parseInt(newIndex as string);
        }
        if (newIndex === 'null') {
          return undefined;
        }
        return prevIndex;
      });
    }
  }, [annotations]);

  if (!isFair) {
    return undefined;
  }

  let filteredFields = fields || [];
  if (betterOptionForQuestions === undefined) {
    filteredFields = filteredFields.filter(field => field.field_id !== isResponsePerfectFieldId);
  }

  return { filteredFields };
};
